import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import {
  fetchGetUser,
  fetchGetBusinessUser,
  fetchAccountPlans,
  fetchAccountPlansActivation
} from 'alelo-logic/actions'

import Header from '../../modules/Header'
import Submenu from '../../elements/Submenu'
import FooterSmall from '../../elements/FooterSmall'
import PageLoader from 'app/modules/PageLoader'
import { setLoading } from '../../modules/PageLoader/actions'

import { subnavLinks } from './data.json'

import { RouteWithSubRoutes } from '../../../routes'

class TemplateLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  async componentDidMount() {
    this.props.setLoading(true)
    if ((this.props.account || {}).pc) {
      await this.props.getAccountPlansActivation()
    } else {
      await this.props.getAccountPlans()
    }
    await this.props.getUser(this.props.account.accountType)
  }

  shouldComponentUpdate(nextProps) {
    const hasChange = nextProps.location.pathname !== this.props.location.pathname
    return hasChange
  }

  render() {
    const { routes, location, account } = this.props

    return (
      <div>
        <div className="empty-template">
          <Header userCancelled={!account.active} />
          {account.active && (
            // <Submenu lastItemOnRight navItems={subnavLinks[account.accountType]} />
            // Substituir a linha abaixo pela linha de cima, quando for voltar o menu de cancelar conta, e voltar os links no json do arquivo TemplateLayout/data.json
            <Submenu
              navItems={subnavLinks[(this.props.account || {}).pc ? 'pc' : account.accountType]}
            />
          )}
        </div>
        <TransitionGroup>
          <CSSTransition key={location.key} timeout={500} exit={false} classNames="fade-in">
            <PageLoader>
              <div>
                {routes.map(route => (
                  <RouteWithSubRoutes user={this.state.user} key={route.path} {...route} />
                ))}
              </div>
            </PageLoader>
          </CSSTransition>
        </TransitionGroup>
        <div className="empty-template">
          <FooterSmall />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  account: state.reducer.account,
  user: state.reducer.user
})

const mapDispatchToProps = dispatch => ({
  getAccountPlans: () => dispatch(fetchAccountPlans()),
  getAccountPlansActivation: () => dispatch(fetchAccountPlansActivation()),
  getUser: userType => {
    if (userType === 'pf') {
      dispatch(fetchGetUser())
    } else {
      dispatch(fetchGetBusinessUser()).finally(() => dispatch(setLoading(false)))
    }
  },
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(TemplateLayout)



// WEBPACK FOOTER //
// ./src/app/templates/TemplateLayout/index.js